<template>
  <div class="page-title">
    <span v-if="emoji" class="emoji">{{ emoji }}</span>
    <PageIcon v-else />
    <span class="name">{{ title || "Loading..." }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

import PageIcon from "@/components/icons/PageIcon.vue";
import * as inject from "@/components/inject";
import { useEmoji } from "@/composables/useEmoji";
import { useReleaser } from "@/ref";

export default defineComponent({
  name: "PageTitle",
  components: {
    PageIcon,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  async setup(props) {
    const controller = inject.controller();
    const { title, emoji, updateText } = useEmoji();
    const pageId = ref(props.pageId);
    const releaser = useReleaser();
    const page = await releaser.add(controller.page.get(pageId.value));

    releaser.defer(
      watch(
        page,
        (page) => {
          if (!page) return;
          updateText(page.title || "Untitled");
        },
        { immediate: true }
      )
    );

    return {
      title,
      emoji,
    };
  },
});
</script>

<style lang="scss" scoped>
@use "@/styles/emoji.scss";

.page-title {
  display: flex;
  align-items: center;
  width: 100%;

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
